const useGetExcelStyles = () => {
  const excelStyles = [
    {
      id: 'date',
      dataType: 'DateTime',
      numberFormat: {
        format: 'MM\\/DD\\/YY',
      },
    },
    {
      id: 'datetime',
      dataType: 'DateTime',
      numberFormat: {
        format: 'MM\\/DD\\/YY HH:mm',
      },
    },
    /** Setting Group Header cell background color for custom excel */
    {
      id: 'truck-dmg-group-header',
      interior: {
        pattern: 'Solid',
        color: '#FBE2D5',
      },
    },
    {
      id: 'steer-tires-group-header',
      interior: {
        pattern: 'Solid',
        color: '#F7C7AC',
      },
    },
    {
      id: 'drive-tires-group-header',
      interior: {
        pattern: 'Solid',
        color: '#F1A983',
      },
    },
    {
      id: 'equipment-group-header',
      interior: {
        pattern: 'Solid',
        color: '#DAE9F8',
      },
    },
    {
      id: 'equipment-tires-group-header',
      interior: {
        pattern: 'Solid',
        color: '#A6C9EC',
      },
    },
    /** Setting Cell for custom excel in Damage Report */
    {
      id: 'dmg-header',
      alignment: {
        horizontal: 'Center',
        vertical: 'Center',
        wrapText: true,
      },
    },
    {
      id: 'dmg-group-header',
      font: {
        bold: true,
      },
      alignment: {
        horizontal: 'Center',
        vertical: 'Center',
      },
    },
    {
      id: 'dmg-boolean-cell',
      alignment: {
        horizontal: 'Center',
      },
    },
  ];
  return { excelStyles };
};

export default useGetExcelStyles;
